




















































































































import {
	computed,
	defineComponent,
	PropType,
	ref,
} from '@vue/composition-api';
import { STATUS } from '@front-app/constants/state';
import { UploadState } from '@front-app/store/modules/uploadsStore';
import { Size } from '@front-app/components/constants';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import IconButton from '@front-app/components/buttons/IconButton.vue';
import ProgressBar from '../header/ProgressBar.vue';
import SimpleCard from '../cards/SimpleCard.vue';
import LoaderState from '../LoaderState.vue';

// Progress is only worth 90%
const PROGRESS_MODIFIER = 0.9;

export default defineComponent({
	components: {
		ProgressBar,
		SimpleCard,
		LoaderState,
		IconButton,
		FontAwesomeIcon,
	},
	props: {
		uploads: {
			type: Array as PropType<UploadState[]>,
			required: true,
		},
		errors: {
			type: Array as PropType<UploadState[]>,
			required: true,
		},
	},
	setup(props) {
		const isMinimized = ref(false);
		const numCompleted = computed(() => props.uploads
			.filter(({ status }) => status === STATUS.SUCCESS)
			.length);
		const totalProgress = computed(() => {
			// This to deal with weird floating point errors like 0.999...
			if (numCompleted.value === props.uploads.length) {
				return 1;
			}
			return props.uploads
				.map(({ progress, status }) => (status === STATUS.SUCCESS ? 1 : (progress * PROGRESS_MODIFIER)))
				.reduce((acc, curr) => acc + (curr / props.uploads.length), 0);
		});
		return {
			Size,
			totalProgress,
			numCompleted,
			isMinimized,
		};
	},
});
